import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.open('https://codexvital.com/cart/45360389783596:1', '_blank');
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-gold text-nightBlue font-montserrat font-bold text-lg md:text-xl 
        py-4 px-8 rounded-full shadow-[0_4px_14px_0_rgba(201,168,76,0.39)]
        hover:shadow-[0_6px_20px_rgba(201,168,76,0.6)] transition-shadow duration-300
        ${className}
      `} data-id="element-21">
      {children}
    </motion.button>;
}